export const parseStringBool = (
  value:
    | { autoreview_activated: string | boolean }
    | { autoreview_enabled: string | boolean }
): boolean => {
  const newValue: string | boolean =
    (value as { autoreview_activated: string | boolean })
      .autoreview_activated ??
    (value as { autoreview_enabled: string | boolean }).autoreview_enabled;

  switch (typeof newValue) {
    case 'string':
      switch (newValue.toLowerCase()) {
        case 'true':
          return true;
        case 'false':
          return false;
        default:
          throw new Error('The value could not be interpreted as a boolean');
      }
    case 'boolean':
      return newValue;
    default:
      throw new Error('The value could not be interpreted as a boolean');
  }
};
